import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';
import { RichTextContent } from '../RichTextContent';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([0, rem(3)], [0, 7.5])};

        ${theme.breakpoints.up('desktop')} {
            display: flex;
            flex-direction: column;
            align-items: center;
            max-width: ${theme.tggSpacing(rem(84.4), 211)};
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
        }
    `};
`;

export const StyledHeading = styled(Heading, {
    shouldForwardProp: property =>
        typeof property === 'string' && !property.startsWith('$'),
})<{ $withSpacing: boolean }>`
    ${({ theme, $withSpacing }: { theme: Theme; $withSpacing: boolean }) => `
        margin-bottom: ${$withSpacing ? `${theme.tggSpacing(rem(3), 7.5)}` : 'revert'};

        ${theme.breakpoints.up('desktop')} {
            margin-bottom: ${
                $withSpacing ? `${theme.tggSpacing(rem(6), 15)}` : 'revert'
            };
        }
    `};
`;

export const StyledRichTextContent = styled(RichTextContent)`
    max-width: 100%;

    p {
        ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    }
`;
